






import { Component, Vue } from 'vue-property-decorator';
import CustomerList from '@/components/Customer/CustomerList.vue';

@Component({
  components: {
    CustomerList,
  },
})
export default class Customers extends Vue {}
